import React from "react";
import { KPIEditScreenProps } from "../KPIEditParamList";
import { KPIEditSectionsComponent } from "./KPIEditSectionsComponent";
import { graphql, useLazyLoadQuery } from "react-relay";
import { LazyQueryNetworkBoundrary } from "../../../../components/mobile/QueryNetworkBoundrary";
import { KPIEditSectionsQuery } from "./__generated__/KPIEditSectionsQuery.graphql";

const KPI_EDIT_SECTIONS_QUERY = graphql`
  query KPIEditSectionsQuery($routineId: ID!) {
    currentStore @required(action: THROW) {
      ...KPIEditSectionsComponent_Store
    }
    routine(id: $routineId) {
      ...KPIEditSectionsComponent_Routine
    }
  }
`;

export function KPIEditSections(props: KPIEditScreenProps<"KPIEditSections">) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => <InnerKPIEditSections {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerKPIEditSections({
  fetchKey,
  ...props
}: KPIEditScreenProps<"KPIEditSections"> & { fetchKey: string }) {
  const data = useLazyLoadQuery<KPIEditSectionsQuery>(
    KPI_EDIT_SECTIONS_QUERY,
    {
      routineId: props.route.params.routineId,
    },
    { fetchKey, fetchPolicy: "store-and-network" }
  );

  return data.routine ? (
    <KPIEditSectionsComponent
      {...props}
      routine={data.routine}
      store={data.currentStore}
    />
  ) : null;
}
